import { scorCount } from 'i18n/scorLocale';

export const formatScorOutcomeLabel = (count?: number | null): string => scorCount('outcomeLabel', count ?? 0);
